import { InternationalPremiumServicesContainer } from "@containers/Checkout/InternationalPremiumServicesContainer";

const InternationalPremiumServicesPage = () => (
    <InternationalPremiumServicesContainer />
);

export default InternationalPremiumServicesPage;
